export enum PopoutTheme {
  Light,
  Dark,
  Teal,
}
